module.exports = __webpack_public_path__ + "images/icon-check-items-2bdce6efda9cf142c57181b5ace8d42b.svg";